import { useTranslation } from 'react-i18next';
import React, { FC } from 'react';
import { SList, SLink } from './styles';
import { useSessionStore } from 'stores/session';
import { UserRole } from 'core/enums/userRole';
import Chart from 'images/icons/Chart.svg?react';
import Network from 'images/icons/Network.svg?react';
import File from 'images/icons/File.svg?react';
import SearchIcon from 'images/icons/Search.svg?react';

interface ActionsProps {
    userRole: UserRole;
}

const CandidateActions: FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <li>
                <SLink title={t('header.dashboard')} to="/dashboard">
                    <Chart />
                    <span>{t('header.dashboard')}</span>
                </SLink>
            </li>
            <li>
                <SLink title={t('header.contact')} to="/contacts">
                    <Network />
                    <span>{t('header.contact')}</span>
                </SLink>
            </li>
            <li>
                <SLink title={t('common.activities')} to="/activities">
                    <File />
                    <span>{t('common.activities')}</span>
                </SLink>
            </li>
            <li>
                <SLink title={t('common.applications')} to="/applications">
                    <File />
                    <span>{t('common.applications')}</span>
                </SLink>
            </li>
            <li>
                <SLink title={t('page.global-search.nav-label')} to="/search">
                    <SearchIcon />
                    <span>{t('page.global-search.nav-label')}</span>
                </SLink>
            </li>
        </>
    );
};

const AdminActions: FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <li>
                <SLink title={t('header.candidates')} to="/candidates">
                    <Network />
                    <span>{t('header.candidates')}</span>
                </SLink>
            </li>
            <li>
                <SLink title={t('header.agencies')} to="/agencies">
                    <Network />
                    <span>{t('header.agencies')}</span>
                </SLink>
            </li>
        </>
    );
};

const AgencyAdminActions: FC = () => {
    const { t } = useTranslation();
    return (
        <li>
            <SLink title={t('header.candidates')} to="/candidates">
                <Network />
                <span>{t('header.candidates')}</span>
            </SLink>
        </li>
    );
};

const Actions: FC<ActionsProps> = ({ userRole }) => {
    switch (userRole) {
        case UserRole.Candidate:
            return <CandidateActions />;
        case UserRole.AgencyAdmin:
            return <AgencyAdminActions />;
        case UserRole.Admin:
            return <AdminActions />;
        default:
            throw Error('Wrong user role type enum in header actions');
    }
};

const ConnectedActions: FC = () => {
    const user = useSessionStore((s) => s.user);

    if (!user) {
        return null;
    }

    return (
        <SList>
            <Actions
                userRole={user.role as UserRole}
            />
        </SList>
    );
};

export default ConnectedActions;
